import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

const inp = { background: '#fff', border: '1px solid #d1d5db', color: '#111827', borderRadius: 8, padding: '7px 10px', fontSize: 13 };
const leeg = { naam: '', bron: 'storing_oorzaak', trefwoord: '', drempel_aantal: 3, periode_dagen: 90, doel_afdeling_id: '', bericht: '', actie: 'melding', mail_naar: '', actief: true };

function RegelRij({ rij, afdelingen, busy, onOpslaan, onVerwijder, onAnnuleren, isNieuw }) {
  const [l, setL] = useState(rij);
  useEffect(() => { setL(rij); }, [rij.id]);
  return (
    <div style={{ border: '1px solid #e5e7eb', borderRadius: 10, padding: '14px 16px', marginBottom: 12, background: '#fafafa' }}>
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 10 }}>
        <input style={{ ...inp, flex: '1 1 240px' }} placeholder="Naam (bv. Vaker reinigen bij vervuiling)" value={l.naam} onChange={e => setL({ ...l, naam: e.target.value })} />
        <select style={inp} value={l.bron} onChange={e => setL({ ...l, bron: e.target.value })}>
          <option value="storing_oorzaak">Uit storing (oorzaak)</option>
          <option value="log_trefwoord">Uit de log (beschrijving)</option>
        </select>
      </div>
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 10, alignItems: 'center' }}>
        <input style={{ ...inp, width: 180 }} placeholder="Trefwoord (bv. vervuil)" value={l.trefwoord} onChange={e => setL({ ...l, trefwoord: e.target.value })} />
        <span style={{ fontSize: 13, color: '#6b7280' }}>vanaf</span>
        <input style={{ ...inp, width: 60 }} type="number" min="1" value={l.drempel_aantal} onChange={e => setL({ ...l, drempel_aantal: parseInt(e.target.value, 10) || 1 })} />
        <span style={{ fontSize: 13, color: '#6b7280' }}>keer in</span>
        <input style={{ ...inp, width: 70 }} type="number" min="1" value={l.periode_dagen} onChange={e => setL({ ...l, periode_dagen: parseInt(e.target.value, 10) || 1 })} />
        <span style={{ fontSize: 13, color: '#6b7280' }}>dagen naar</span>
        <select style={inp} value={l.doel_afdeling_id || ''} onChange={e => setL({ ...l, doel_afdeling_id: e.target.value ? parseInt(e.target.value, 10) : '' })}>
          <option value="">-- afdeling --</option>
          {afdelingen.map(a => <option key={a.id} value={a.id}>{a.naam}</option>)}
        </select>
      </div>
      <textarea style={{ ...inp, width: '100%', minHeight: 48, marginBottom: 10, boxSizing: 'border-box' }} placeholder="Bericht dat in de melding komt" value={l.bericht || ''} onChange={e => setL({ ...l, bericht: e.target.value })} />
      <div style={{ display: 'flex', gap: 10, alignItems: 'center', marginBottom: 10, flexWrap: 'wrap' }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 13 }}>
          <input type="checkbox" checked={l.actie === 'mail' || l.actie === 'beide'} onChange={e => setL({ ...l, actie: e.target.checked ? 'beide' : 'melding' })} style={{ width: 15, height: 15, cursor: 'pointer' }} />
          <span>Ook e-mailen naar uitvoerder</span>
        </label>
        {(l.actie === 'mail' || l.actie === 'beide') && (
          <input style={{ ...inp, flex: '1 1 240px' }} type="email" placeholder="e-mailadres uitvoerder" value={l.mail_naar || ''} onChange={e => setL({ ...l, mail_naar: e.target.value })} />
        )}
      </div>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <div onClick={() => setL({ ...l, actief: !l.actief })} style={{ cursor: 'pointer', fontSize: 11.5, fontWeight: 600, padding: '3px 12px', borderRadius: 20, background: l.actief ? '#ecfdf5' : '#f3f4f6', color: l.actief ? '#047857' : '#6b7280', border: '1px solid ' + (l.actief ? '#a7f3d0' : '#d1d5db') }}>{l.actief ? 'actief' : 'uit'}</div>
        <button onClick={() => onOpslaan(l, isNieuw)} disabled={busy} style={{ background: '#00D4AA', color: '#fff', border: 'none', padding: '7px 16px', borderRadius: 6, cursor: 'pointer', fontSize: 12.5, fontWeight: 600 }}>{busy ? '...' : 'Opslaan'}</button>
        {isNieuw
          ? <button onClick={onAnnuleren} style={{ background: '#f3f4f6', color: '#111827', border: '1px solid #d1d5db', padding: '7px 16px', borderRadius: 6, cursor: 'pointer', fontSize: 12.5 }}>Annuleren</button>
          : <button onClick={() => onVerwijder(rij.id)} style={{ background: '#7f1d1d', color: '#fff', border: 'none', padding: '7px 16px', borderRadius: 6, cursor: 'pointer', fontSize: 12.5 }}>Verwijderen</button>}
      </div>
    </div>
  );
}

export default function SignaleringBeheer() {
  const navigate = useNavigate();
  const [regels, setRegels] = useState([]);
  const [afdelingen, setAfdelingen] = useState([]);
  const [nieuw, setNieuw] = useState(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');

  const laad = useCallback(async () => {
    try {
      const r = await api.get('/analyse/signalering/regels');
      setRegels(r.data.regels || []);
    } catch (e) { setMsg('Kon regels niet laden'); }
    try {
      const a = await api.get('/afdelingen');
      setAfdelingen((a.data.afdelingen || a.data || []).filter(x => x && x.id));
    } catch (e) { /* afdelingen optioneel */ }
  }, []);
  useEffect(() => { laad(); }, [laad]);

  const opslaan = async (regel, isNieuw) => {
    setBusy(true); setMsg('');
    try {
      if (isNieuw) await api.post('/analyse/signalering/regels', regel);
      else await api.put('/analyse/signalering/regels/' + regel.id, regel);
      setNieuw(null); await laad();
    } catch (e) { setMsg('Opslaan mislukt'); }
    setBusy(false);
  };
  const verwijder = async (id) => {
    if (!window.confirm('Deze regel verwijderen?')) return;
    setBusy(true);
    try { await api.delete('/analyse/signalering/regels/' + id); await laad(); }
    catch (e) { setMsg('Verwijderen mislukt'); }
    setBusy(false);
  };

  return (
    <div style={{ maxWidth: 900, margin: '0 auto', padding: '24px 20px' }}>
      <button onClick={() => navigate('/analyse')} style={{ background: 'none', border: 'none', color: '#00D4AA', cursor: 'pointer', fontSize: 13, marginBottom: 8 }}>&larr; Terug naar analyse</button>
      <h1 style={{ fontSize: 22, marginBottom: 4 }}>{'\U0001F514'} Auto-signalering</h1>
      <p style={{ color: '#6b7280', fontSize: 14, marginBottom: 20 }}>Stel regels in die automatisch een melding sturen naar een afdeling zodra een patroon te vaak voorkomt. Meldingen verschijnen in de app bij de gekozen afdeling.</p>
      {msg && <div style={{ background: '#fef2f2', color: '#b91c1c', padding: '8px 12px', borderRadius: 8, marginBottom: 12, fontSize: 13 }}>{msg}</div>}

      {regels.map(r => (
        <RegelRij key={r.id} rij={r} afdelingen={afdelingen} busy={busy} onOpslaan={opslaan} onVerwijder={verwijder} />
      ))}

      {nieuw
        ? <RegelRij rij={nieuw} afdelingen={afdelingen} busy={busy} onOpslaan={opslaan} onAnnuleren={() => setNieuw(null)} isNieuw />
        : <button onClick={() => setNieuw({ ...leeg })} style={{ background: '#00D4AA', color: '#fff', border: 'none', padding: '10px 18px', borderRadius: 8, cursor: 'pointer', fontSize: 14, fontWeight: 600, marginTop: 8 }}>+ Nieuwe regel</button>}

      {regels.length === 0 && !nieuw && <p style={{ color: '#9ca3af', fontSize: 14, marginTop: 16 }}>Nog geen regels. Maak er een aan om te beginnen.</p>}
    </div>
  );
}
